import { ThemeFactory } from '@skbkontur/react-ui/lib/theming/ThemeFactory';
import { is8pxTheme, isFlatTheme } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
import { memo } from '../utils/memo';
import { AddonsThemeInternal, isAddonsTheme } from '../../internal/themes/AddonsTheme';
import { AddonsThemeFlatInternal } from '../../internal/themes/AddonsFlatTheme';
import { AddonsTheme8pxInternal } from '../../internal/themes/AddonsTheme8px';

var constructAddonsTheme = function constructAddonsTheme(theme) {
  var deafultTheme = Object.create(Object.getPrototypeOf(theme), // ReactUI's vars
  Object.getOwnPropertyDescriptors(AddonsThemeInternal) // Addons default vars
  );
  var flatTheme = Object.create(deafultTheme, Object.getOwnPropertyDescriptors(AddonsThemeFlatInternal) // Addons flat vars
  );
  var default8pxTheme = Object.create(deafultTheme, Object.getOwnPropertyDescriptors(AddonsTheme8pxInternal) // Addons 8px vars
  );
  var flat8pxTheme = Object.create(flatTheme, Object.getOwnPropertyDescriptors(AddonsTheme8pxInternal) // Addons 8px vars
  );

  switch (true) {
    case isFlatTheme(theme) && is8pxTheme(theme):
      return flat8pxTheme;

    case isFlatTheme(theme):
      return flatTheme;

    case is8pxTheme(theme):
      return default8pxTheme;

    default:
      return deafultTheme;
  }
};
/**
 * Makes the AddonsTheme out of the ReactUI's Theme
 * by inserting corresponding addons vars
 * between user's custom vars (theme's own properties)
 * and the ReactUI's Theme vars (theme's prototype).
 * (see ThemeFactory.create)
 */


export var getAddonsTheme = memo(function (theme) {
  return isAddonsTheme(theme) ? theme : ThemeFactory.create(theme, constructAddonsTheme(theme));
});

function isZeroArgs(fn) {
  return fn.length == 0;
}

var memoize = function memoize(fn) {
  if (isZeroArgs(fn)) {
    var isCalled_1 = false;
    var result_1;
    return function () {
      if (!isCalled_1) {
        isCalled_1 = true;
        result_1 = fn();
      }

      return result_1;
    };
  }

  var cache = new WeakMap();
  return function (arg) {
    if (!cache.has(arg)) cache.set(arg, fn(arg));
    return cache.get(arg);
  };
};

export var memoizeStyle = function memoizeStyle(styles) {
  Object.keys(styles).forEach(function (className) {
    return styles[className] = memoize(styles[className]);
  });
  return styles;
};
export var cssName = function cssName(className) {
  return "." + className;
};